import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { BorderThemeProps } from 'shared/common/themes/theme';
import { ResetButton } from 'shared/components/buttons/ResetButton/ResetButton';

import { BorderPanel } from '../../../../../../components/controlledPanels/BorderPanel/BorderPanel';
import { FormControl } from '../../../../../../components/controlledPanels/FormControl/FormControl';
import { SwitchPanel } from '../../../../../../components/controlledPanels/SwitchPanel/SwitchPanel';
import { DEFAULT_BORDER, DEFAULT_IS_BORDER_VISIBLE } from '../../consts';
import type { TooltipConfigProps } from '../TooltipConfig';

export function Borders(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, onUpdateStyle } = props;
  const { t } = useTranslation('components.theme.settings');

  const setBorder = useCallback(
    (newBorder: BorderThemeProps) => {
      onUpdateStyle({ border: newBorder });
    },
    [onUpdateStyle]
  );

  const setIsBorderVisible = useCallback(
    (newIsBorderVisible: boolean) => {
      onUpdateStyle({ isBorderVisible: newIsBorderVisible });
    },
    [onUpdateStyle]
  );

  return (
    <FormControl title={t('borders')}>
      <SwitchPanel
        value={styles.isBorderVisible ?? DEFAULT_IS_BORDER_VISIBLE}
        onChange={setIsBorderVisible}
        ResetButton={'isBorderVisible' in styles && <ResetButton onClick={() => onRemoveStyle('isBorderVisible')} />}
      />
      <BorderPanel
        label={t('borderStyle')}
        border={{ ...DEFAULT_BORDER, ...styles.border }}
        setBorder={setBorder}
        resetButton={styles.border && <ResetButton onClick={() => onRemoveStyle('border')} />}
      />
    </FormControl>
  );
}
